import React from "react";
import SMS from "./SMS";

export default function index() {
  return (
    <div className="p-0 m-0">
      <header className="header no-border">
        <div className="header-info">
          <div className="left">
            <h2 className="header-title">
              <strong>Notification Management</strong>
              <small className="subtitle">
                Here you can Send Notification To Users, Customers, Account
                Head, Employee..
              </small>
            </h2>
          </div>
        </div>
        {/* <div className="header-action">
          <nav className="nav">
            <Links className="nav-link" activeClassName="active" to={`./`}>
              Table
            </Links>
            <Links
              className="nav-link"
              activeClassName="active"
              to={`./TableGroup`}
            >
              Table Group
            </Links>
          </nav>
        </div> */}
      </header>
      <SMS />
    </div>
  );
}
